import React from "react";

const quickLinks = [
  {
    img: "https://www.earthytales.in/assets/2024/images/bg/ql1.png",
    text: "Founder's Diaries",
    link: "https://www.earthytales.in/founders-message",
  },
  {
    img: "https://www.earthytales.in/assets/2024/images/bg/ql2.png",
    text: "Our Journey",
    link: "https://www.earthytales.in/our-story",
  },
  {
    img: "https://www.earthytales.in/assets/2024/images/bg/ql3.png",
    text: "Farmers Stories",
    link: "https://www.earthytales.in/farm-diaries",
  },
  {
    img: "https://www.earthytales.in/assets/2024/images/bg/ql4.png",
    text: "Certificates",
    link: "https://www.earthytales.in/certification",
  },
  {
    img: "https://www.earthytales.in/assets/2024/images/bg/ql5.png",
    text: "Farmers Markets",
    link: "https://www.earthytales.in/farmer-markets",
  },
  {
    img: "https://www.earthytales.in/assets/2024/images/bg/ql6.png",
    text: "Refer & Plant",
    link: "https://www.earthytales.in/refer-and-plant",
  },
];

const FounderSection = () => {
  return (
    <>
      <style>{`
        .founder-section {
          background-color: var(--bg-main);
          padding: var(--space-lg) var(--space-sm);
          color: var(--color-secondary);
        }
        .founder-container {
          max-width: 1200px;
          margin: 0 auto;
        }
        .founder-msg {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          margin-bottom: var(--space-lg);
          gap: var(--space-md);
        }
        .founder-img img {
          width: 200px;
          border-radius: 50%;
          object-fit: cover;
        }
        .founder-content {
          flex: 1;
        }
        .quote {
          font-size: var(--font-lg);
          font-style: italic;
          margin-bottom: var(--space-sm);
          line-height: 1.6;
          font-family: var(--font-secondary);
        }
        .founder-name {
          font-size: var(--font-base);
          margin-bottom: var(--space-xs);
          font-weight: bold;
          font-family: var(--font-primary);
        }
        .founder-desc {
          font-size: var(--font-sm);
          line-height: 1.6;
          max-width: 700px;
          font-family: var(--font-secondary);
        }
        .quick-links {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: var(--space-md);
        }
        .link-item {
          text-align: center;
          width: 150px;
        }
        .link-item img {
          width: 100%;
          border-radius: 50%;
          margin-bottom: var(--space-xs);
          transition: transform 0.3s;
        }
        .link-item img:hover {
          transform: scale(1.05);
        }
        .link-item span {
          display: block;
          font-size: var(--font-sm);
          color: var(--color-secondary);
        }
      `}</style>

      <section className="founder-section">
        <div className="founder-container">
          {/* Founder Message */}
          <div className="founder-msg">
            <div className="founder-img">
              <img
                src="https://www.earthytales.in/assets/2024/images/bg/deepak-et.png"
                alt="Founder"
              />
            </div>
            <div className="founder-content">
              <p className="quote">
                <i>
                  "When you choose Earthy Tales, you can be sure about what you
                  are consuming, like my own family."
                </i>
              </p>
              <p className="founder-name">
                Deepak Sabharwal
                <br />
                A Father, An Organic Farmer & Co-Founder Earthy Tales, An Ex-TATA,
                Pepsi & GE alumni
              </p>
              <p className="founder-desc">
                Earthy Tales Organics was founded in 2017 by Deepak, who quit his
                corporate life of two decades after his mother was diagnosed with
                carcinoma, to bring about a change in how we grow and consume our
                food. His love for hands-on farming started in 2012 at his family
                farms in Pushkar, Rajasthan.
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div className="quick-links">
            {quickLinks.map((item, index) => (
              <div key={index} className="link-item">
                <a href={item.link} target="_blank" rel="noreferrer">
                  <img src={item.img} alt={item.text} />
                  <span>{item.text}</span>
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default FounderSection;
